module.exports = __webpack_public_path__ + "media/images/choose/discussions_student-7d38f8727a8f709dde20c777028dc97e.png";